{
  "controls": {
    "back": "Retour",
    "close": "Fermer",
    "last": "Terminé",
    "next": "Suivant",
    "skip": "Passer la visite"
  },
  "dashboard": {
    "greeting": {
      "title": "Bienvenue sur votre tableau de bord",
      "body": "Voici votre page d'accueil — un aperçu rapide des opportunités, snipes et de vos meilleurs royaumes."
    },
    "kpi": {
      "title": "Opportunités en direct",
      "body": "Nombre de flips rentables disponibles à cet instant dans tous vos outils."
    },
    "topOpportunities": {
      "title": "Meilleures opportunités",
      "body": "Aperçu en direct des meilleurs flips. Changez d'onglet pour voir les ventes rapides ou les meilleurs achats."
    },
    "snipeAlerts": {
      "title": "Snipes récents",
      "body": "Alertes de snipe déclenchées lors du dernier cycle de mise à jour. Cliquez pour configurer de nouvelles alertes."
    },
    "realmStats": {
      "title": "Meilleurs royaumes",
      "body": "Vos royaumes de vente les plus performants, triés par population, enchères ou rapport de prix."
    },
    "quickActions": {
      "title": "Accès rapide",
      "body": "Accédez directement à n'importe quel outil depuis ici."
    }
  },
  "flipping": {
    "dataFreshness": {
      "title": "Statut des données",
      "body": "Indique la fraîcheur des données d'hôtel des ventes. La page se rafraîchit automatiquement à l'arrivée de nouvelles données."
    },
    "filters": {
      "title": "Barre de filtres",
      "body": "Affinez les résultats par royaume, qualité, profit, taux de vente, etc. Enregistrez vos combinaisons favorites comme préréglages."
    },
    "stats": {
      "title": "Résumé d'investissement",
      "body": "Totaux des flips visibles : investissement requis, revenu estimé et profit après commission de l'hôtel des ventes."
    },
    "table": {
      "title": "Opportunités",
      "body": "Chaque ligne est un flip : achetez sur un royaume, revendez sur un autre. Cliquez un objet pour le copier ou l'ajouter aux favoris."
    },
    "pagination": {
      "title": "Pagination",
      "body": "Parcourez les pages de résultats et choisissez combien d'objets afficher à la fois."
    }
  },
  "housing": {
    "dataFreshness": {
      "title": "Statut des données",
      "body": "Indique la fraîcheur des données housing et l'heure prévue de la prochaine mise à jour."
    },
    "filters": {
      "title": "Barre de filtres",
      "body": "Affinez les flips housing par royaume, profit, taux de vente et plafond de buyout."
    },
    "stats": {
      "title": "Résumé d'investissement",
      "body": "Totaux des flips housing visibles pour calibrer votre budget avant d'acheter."
    },
    "table": {
      "title": "Opportunités housing",
      "body": "Chaque ligne est un objet housing bon marché sur un royaume et plus précieux sur un autre."
    },
    "pagination": {
      "title": "Pagination",
      "body": "Parcourez les pages et ajustez le nombre de résultats affichés."
    }
  },
  "dropship": {
    "dataFreshness": {
      "title": "Statut des données",
      "body": "Indique la fraîcheur des données dropship et l'heure prévue de la prochaine mise à jour."
    },
    "filters": {
      "title": "Barre de filtres",
      "body": "Affinez les opportunités dropship par royaume, qualité, extension et rentabilité."
    },
    "stats": {
      "title": "Résumé d'investissement",
      "body": "Totaux des trades dropship visibles — utile pour planifier capital et capacité."
    },
    "table": {
      "title": "Opportunités dropship",
      "body": "Chaque ligne est un objet à acheter sur un royaume et revendre sur un autre avec marge."
    },
    "pagination": {
      "title": "Pagination",
      "body": "Parcourez les pages de résultats dropship."
    }
  },
  "inventory": {
    "realms": {
      "title": "Royaumes de vente",
      "body": "Choisissez les royaumes contre lesquels analyser votre inventaire."
    },
    "csv": {
      "title": "Collez votre inventaire",
      "body": "Collez ici un CSV de votre stock séparé par des points-virgules — l'outil cherchera les échanges inter-royaumes rentables."
    },
    "analyze": {
      "title": "Analyser",
      "body": "Lancez l'analyse inter-royaumes sur l'inventaire que vous venez de coller."
    },
    "results": {
      "title": "Recommandations de flip",
      "body": "Chaque ligne est un objet de votre inventaire qui vaut plus sur un autre royaume."
    },
    "export": {
      "title": "Exporter",
      "body": "Téléchargez l'analyse au format CSV pour l'utiliser dans un tableur ou un addon."
    }
  },
  "stats": {
    "table": {
      "title": "Statistiques de royaume",
      "body": "Comparez les prix d'enchère, le nombre d'annonces et les tendances sur tous les royaumes de votre région."
    }
  },
  "tsm": {
    "filters": {
      "title": "Filtres",
      "body": "Choisissez quels objets inclure selon la catégorie, l'extension, la qualité et le profit."
    },
    "table": {
      "title": "Liste d'objets",
      "body": "Objets correspondant à vos filtres — copiez-les directement dans une opération TSM Price Source."
    },
    "pagination": {
      "title": "Pagination",
      "body": "Parcourez les pages et choisissez combien d'objets afficher à la fois."
    }
  },
  "snipe": {
    "tabs": {
      "title": "Catégories d'alertes",
      "body": "Basculez entre snipes d'objets, snipes de familiers, jeton WoW et règles d'iLvl."
    },
    "add": {
      "title": "Ajouter une alerte",
      "body": "Ajoutez un objet, un familier ou une règle à votre liste — vous serez prévenu dès qu'il passe sous votre prix cible."
    },
    "list": {
      "title": "Alertes actives",
      "body": "Vos alertes configurées avec leurs prix cibles et leurs canaux webhook."
    },
    "import": {
      "title": "Import en masse",
      "body": "Importez une liste entière d'un coup : cliquez sur Importer pour choisir un fichier, ou collez simplement une liste copiée n'importe où sur cette page. Un aperçu s'affiche avant tout enregistrement."
    },
    "inlineEdit": {
      "title": "Modifier les prix sur place",
      "body": "Cliquez sur un prix dans le tableau pour le modifier directement — Entrée enregistre, Échap annule. Les alertes supprimées peuvent être restaurées avec Annuler, et la liste peut être triée par nom ou par prix."
    }
  },
  "tsmProfile": {
    "video": {
      "title": "Vidéo de configuration",
      "body": "Regardez cette courte vidéo pour la configuration complète du profil TSM."
    },
    "min": {
      "title": "Prix minimum",
      "body": "Copiez cette formule dans votre opération TSM de prix minimum."
    },
    "max": {
      "title": "Prix maximum",
      "body": "Copiez cette formule dans votre opération TSM de prix maximum."
    },
    "normal": {
      "title": "Prix normal",
      "body": "Copiez cette formule dans votre opération TSM de prix normal."
    }
  },
  "settingsRealm": {
    "region": {
      "title": "Région",
      "body": "Choisissez US ou EU — cela pilote toutes les listes de royaumes de l'application."
    },
    "buying": {
      "title": "Royaumes d'achat",
      "body": "Les royaumes où vous achetez bon marché. Ajoutez-en autant que vous pouvez visiter confortablement."
    },
    "selling": {
      "title": "Royaumes de vente",
      "body": "Les royaumes où vous revendez avec profit. Ils apparaissent comme cibles dans chaque outil."
    },
    "accounts": {
      "title": "Comptes WoW",
      "body": "Si vous jouez plusieurs comptes, déclarez-les ici et assignez-leur des royaumes."
    },
    "save": {
      "title": "Enregistrer la config",
      "body": "Enregistrez — le reste de l'app utilisera ces royaumes immédiatement."
    }
  },
  "settingsPersonal": {
    "preview": {
      "title": "Aperçu des filtres",
      "body": "Un aperçu en direct de l'interface de filtres que vous verrez dans les outils de flipping."
    },
    "ranges": {
      "title": "Plages par défaut",
      "body": "Définissez les plages de profit, taux de vente et prix à pré-appliquer dans chaque outil."
    },
    "dashboard": {
      "title": "Seuils du tableau de bord",
      "body": "Contrôlez le buyout min et max des opportunités affichées sur votre tableau de bord."
    },
    "matching": {
      "title": "Correspondance d'objets",
      "body": "Limitez la correspondance des statistiques d'objet à certaines extensions pour des prix inter-royaumes plus justes."
    },
    "save": {
      "title": "Enregistrer les valeurs par défaut",
      "body": "Enregistrez ces réglages comme vos valeurs par défaut sur tous les outils."
    }
  },
  "rowActions": {
    "title": "Menu des actions de ligne",
    "body": "La première colonne regroupe désormais l'étoile favori, la case de sélection et la cloche d'alerte de snipe. Ouvre ce menu pour sélectionner / désélectionner la page actuelle ou tout sur l'ensemble des pages, ne garder que tes favoris, ou épingler les favoris, les cibles de snipe et les lignes sélectionnées en haut. Les paramètres des colonnes (réorganisation par glisser-déposer, afficher / masquer) sont aussi ici."
  },
  "settingsDiscord": {
    "link": {
      "title": "Lier Discord",
      "body": "Connectez votre compte Discord pour que le bot puisse vous envoyer alertes et notifications."
    },
    "verification": {
      "title": "Vérifier les DM",
      "body": "Recevez un code à 6 chiffres pour confirmer que le bot peut vous joindre en DM."
    },
    "notifications": {
      "title": "Paramètres de notification",
      "body": "Activez les notifications DM pour les mises à jour de région et autres événements."
    },
    "webhooks": {
      "title": "Catégories de webhook",
      "body": "Créez des catégories de webhook pour router les alertes snipe vers des canaux Discord précis."
    }
  },
  "classicDeals": {
    "controls": {
      "title": "Classic Deals",
      "body": "Pick your region and realms, then find same-realm undercut opportunities."
    },
    "table": {
      "title": "Deals",
      "body": "Each row is an item you can buy at the lowest price and relist just under the next-cheapest listing on the same realm."
    }
  },
  "filterMode": {
    "title": "Filtrer ou recalculer",
    "body": "Choisissez ce qui se passe quand vous modifiez un filtre : « Filtrer » affine instantanément les résultats déjà chargés, « Recalculer » récupère des résultats à jour depuis le serveur."
  }
}
